import { CircleNotchIcon } from '@phosphor-icons/react'
import styled, { keyframes } from 'styled-components'

const rotate = keyframes`
  to {
    transform: rotate(360deg);
  }
`

export const Spinner = styled(CircleNotchIcon)`
  animation: ${rotate} 1s linear infinite;
  flex-shrink: 0;
`
